import React from "react";
import classnames from "classnames";
import {
    DisassociateIcon,
    EyeIcon,
    PencilIcon,
    SettingsIcon,
    TrashIcon,
} from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next/";
import { useSnapshot } from "valtio";
import { Tooltip } from "@mui/material";

import { store as device } from "../../../../components/VerticalLayout/store";
import store, {
    setIsConfigurationCashManagementClicked,
    setIsConfigurationMoneticClicked,
    setIsConfigurationPrinterClicked,
    setSelectedApplicationSco,
} from "../store";
import {
    store as appStore,
    setIsActionsClicked,
    setIsEdited,
    setActions,
} from "../store";

import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";
import ErrorToast from "@components/Common/ErrorTost";
import LinkSvgIcon from "@components/Common/SvgIcons/LinkSvgIcon";

export function CustomIcons({
    e,
    setSelectedRows,
    isAddApplication,
    setIsAddApplication,
    isApplicationArchived,
    setIsHistoryModalOpened,
    isHistoryModalOpened,
    setIsConfirmationModalArchived,
    setIsConfirmationModalActived,
    setIsDeviceAssociateModalOpened,
    setIsDeviceDissociateModalOpened,
    setUrlHistoryPrinter,
    setIsAddPrinterOriginHistoryClicked,
    setEditedData,
}: any) {
    const { t } = useTranslation();
    const { userID, franchiseID } = useSnapshot(device);
    const {
        isConfigurationPrinterClicked,
        isConfigurationCashManagementClicked,
        isConfigurationMoneticClicked,
        modify,
    } = useSnapshot(store);
    const { isActionsClicked, isEdited } = useSnapshot(appStore);
    return (
        <React.Fragment>
            {e.selectedRow?.subRows !== undefined &&
            e.selectedRow["Application"] !== "" ? (
                <div className="d-flex justify-content-between mt-2">
                    {modify === true && (
                        <>
                            <div>
                                <PencilIcon
                                    onClick={() => {
                                        if (isEdited === true) {
                                            setIsActionsClicked(
                                                !isActionsClicked
                                            );
                                            setActions(() => {
                                                setIsEdited(false);
                                                if (!isAddApplication) {
                                                    setIsAddApplication(
                                                        !isAddApplication
                                                    );
                                                }
                                                setSelectedRows([
                                                    e.selectedRow,
                                                ]);
                                                setEditedData(e.selectedRow);
                                            });
                                        } else {
                                            if (!isAddApplication) {
                                                setIsAddApplication(
                                                    !isAddApplication
                                                );
                                            }
                                            setSelectedRows([e.selectedRow]);
                                            setEditedData(e.selectedRow);
                                        }
                                    }}
                                    height={25}
                                    width={25}
                                    style={{ cursor: "pointer" }}
                                    className={`${classnames(
                                        "pointer__clz cmn_icn_edit",
                                        {
                                            "not-allowed-icon__clz": isApplicationArchived,
                                        }
                                    )}`}
                                />
                            </div>
                            <div
                                style={{ position: "relative", bottom: "3px" }}
                            >
                                <Tooltip
                                    title={t(
                                        "Associate a device with an application"
                                    ).toString()}
                                >
                                    <div>
                                        <LinkSvgIcon
                                            className={`${classnames(
                                                "pointer__clz cmn_icn_associate mr-1",
                                                {
                                                    "not-allowed-icon__clz": isApplicationArchived,
                                                }
                                            )}`}
                                            onClick={() => {
                                                if (isEdited === true) {
                                                    setIsActionsClicked(
                                                        !isActionsClicked
                                                    );
                                                    setActions(() => {
                                                        setIsEdited(false);
                                                        setIsDeviceAssociateModalOpened(
                                                            true
                                                        );
                                                        setSelectedRows([
                                                            e.selectedRow,
                                                        ]);
                                                    });
                                                } else {
                                                    setIsAddApplication(false);
                                                    setIsDeviceAssociateModalOpened(
                                                        true
                                                    );
                                                    setSelectedRows([
                                                        e.selectedRow,
                                                    ]);
                                                }
                                            }}
                                            height={30}
                                            width={25}
                                            style={{
                                                position: "relative",
                                                top: "5px",
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                            </div>
                            <div>
                                {!isApplicationArchived ? (
                                    <TrashIcon
                                        onClick={() => {
                                            if (isEdited === true) {
                                                setIsActionsClicked(
                                                    !isActionsClicked
                                                );
                                                setActions(() => {
                                                    setIsEdited(false);
                                                    if (
                                                        e.selectedRow.subRows
                                                            .length > 0
                                                    ) {
                                                        ErrorToast(
                                                            t(
                                                                "Please note that you cannot archive a application associated with an device."
                                                            )
                                                        );
                                                    } else {
                                                        setIsConfirmationModalArchived(
                                                            true
                                                        );
                                                    }
                                                    setSelectedRows([
                                                        e.selectedRow,
                                                    ]);
                                                });
                                            } else {
                                                setIsAddApplication(false);
                                                if (
                                                    e.selectedRow.subRows
                                                        .length > 0
                                                ) {
                                                    ErrorToast(
                                                        t(
                                                            "Please note that you cannot archive a application associated with an device."
                                                        )
                                                    );
                                                } else {
                                                    setIsConfirmationModalArchived(
                                                        true
                                                    );
                                                }
                                                setSelectedRows([
                                                    e.selectedRow,
                                                ]);
                                            }
                                        }}
                                        height={25}
                                        width={25}
                                        fill="red"
                                        style={{ cursor: "pointer" }}
                                        className={`${classnames(
                                            "pointer__clz cmn_icn_archived ml-1"
                                        )}`}
                                    />
                                ) : (
                                    <EyeIcon
                                        height={25}
                                        width={25}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            setIsConfirmationModalActived(true);
                                            setSelectedRows([e.selectedRow]);
                                        }}
                                        className="pointer__clz ml-1"
                                    />
                                )}
                            </div>
                        </>
                    )}
                    <div>
                        <TimePastSvgIcon
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsEdited(false);
                                        setIsAddApplication(!isAddApplication);
                                        setIsHistoryModalOpened(
                                            !isHistoryModalOpened
                                        );
                                        setSelectedApplicationSco([
                                            {
                                                [e.selectedRow.shopId]:
                                                    e.selectedRow.ProjectId,
                                            },
                                        ]);
                                        setSelectedRows([e.selectedRow]);
                                    });
                                } else {
                                    setIsAddApplication(!isAddApplication);
                                    setIsHistoryModalOpened(
                                        !isHistoryModalOpened
                                    );
                                    setSelectedApplicationSco([
                                        {
                                            [e.selectedRow.shopId]:
                                                e.selectedRow.ProjectId,
                                        },
                                    ]);
                                    setSelectedRows([e.selectedRow]);
                                }
                            }}
                            className={`${classnames(
                                "pointer__clz cmn_icn_history",
                                "ml-2"
                            )}`}
                        />
                    </div>
                </div>
            ) : e.selectedRow[t("Peripheral")] !== "" ? (
                <div className="d-flex justify-content-between mt-3">
                    {modify === true && (
                        <React.Fragment>
                            <SettingsIcon
                                className="pointer__clz ml-4"
                                onClick={() => {
                                    if (isEdited === true) {
                                        setIsActionsClicked(!isActionsClicked);
                                        setActions(() => {
                                            setIsEdited(false);
                                            if (
                                                e.selectedRow.peripheralType ===
                                                "printer"
                                            ) {
                                                setSelectedRows(e.selectedRow);
                                                setIsConfigurationPrinterClicked(
                                                    !isConfigurationPrinterClicked
                                                );
                                            } else if (
                                                e.selectedRow.peripheralType ===
                                                "cash_management"
                                            ) {
                                                setSelectedRows(e.selectedRow);
                                                setIsConfigurationCashManagementClicked(
                                                    !isConfigurationCashManagementClicked
                                                );
                                            } else if (
                                                e.selectedRow.peripheralType ===
                                                "monetic"
                                            ) {
                                                setSelectedRows(e.selectedRow);
                                                setIsConfigurationMoneticClicked(
                                                    !isConfigurationMoneticClicked
                                                );
                                            }
                                        });
                                    } else {
                                        setIsAddApplication(!isAddApplication);
                                        if (
                                            e.selectedRow.peripheralType ===
                                            "printer"
                                        ) {
                                            setSelectedRows(e.selectedRow);
                                            setIsConfigurationPrinterClicked(
                                                !isConfigurationPrinterClicked
                                            );
                                        } else if (
                                            e.selectedRow.peripheralType ===
                                            "cash_management"
                                        ) {
                                            setSelectedRows(e.selectedRow);
                                            setIsConfigurationCashManagementClicked(
                                                !isConfigurationCashManagementClicked
                                            );
                                        } else if (
                                            e.selectedRow.peripheralType ===
                                            "monetic"
                                        ) {
                                            setSelectedRows(e.selectedRow);
                                            setIsConfigurationMoneticClicked(
                                                !isConfigurationMoneticClicked
                                            );
                                        }
                                    }
                                }}
                                height={22}
                                width={22}
                            />
                            <DisassociateIcon
                                height={40}
                                width={35}
                                fill="white"
                                style={{ position: "relative", bottom: "10px" }}
                                className={`${classnames("pointer__clz ml-2", {
                                    "not-allowed-icon__clz": isApplicationArchived,
                                })}`}
                                onClick={() => {
                                    if (isEdited === true) {
                                        setIsActionsClicked(!isActionsClicked);
                                        setActions(() => {
                                            setIsEdited(false);
                                            setSelectedRows([e.selectedRow]);
                                            setIsDeviceDissociateModalOpened(
                                                true
                                            );
                                        });
                                    } else {
                                        setIsAddApplication(!isAddApplication);
                                        setSelectedRows([e.selectedRow]);
                                        setIsDeviceDissociateModalOpened(true);
                                    }
                                }}
                            />
                        </React.Fragment>
                    )}
                    <TimePastSvgIcon
                        onClick={() => {
                            if (isEdited === true) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(() => {
                                    setIsEdited(false);
                                    setUrlHistoryPrinter(
                                        `${process.env.REACT_APP_API_V2_URL}/settings/printers/printer/history?userId=${userID}&shopId=${e.selectedRow.shopId}&franchiseId=${franchiseID}&id=${e.selectedRow.peripheralId}`
                                    );
                                    setIsAddPrinterOriginHistoryClicked(true);
                                });
                            } else {
                                setIsAddApplication(!isAddApplication);
                                setUrlHistoryPrinter(
                                    `${process.env.REACT_APP_API_V2_URL}/settings/printers/printer/history?userId=${userID}&shopId=${e.selectedRow.shopId}&franchiseId=${franchiseID}&id=${e.selectedRow.peripheralId}`
                                );
                                setIsAddPrinterOriginHistoryClicked(true);
                            }
                        }}
                        className={`${classnames(
                            "pointer__clz cmn_icn_history",
                            "ml-3"
                        )}`}
                    />
                </div>
            ) : null}
        </React.Fragment>
    );
}
